import { Card, makeStyles, TableBody, TableCell, TableRow, Checkbox, Skeleton, Table, TableHead } from '@paintscout/ui'
import times from 'lodash/times'
import ActionIcon from '@material-ui/icons/MoreHoriz'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 2, 1, 2)
  },
  circle: {
    borderRadius: '50%',
    backgroundColor: theme.paintscout.palette.brand.Neutral.P80,
    marginRight: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(2)
  },
  columnHeader: {
    marginTop: theme.spacing(1.5),
    backgroundColor: theme.paintscout.palette.brand.Neutral.P50
  }
}))

export function TasksShim() {
  const classes = useStyles()
  return (
    <Card>
      <div className={classes.header}>
        {times(5, (i) => (
          <Skeleton className={classes.circle} variant="rect" width={'25px'} height={'25px'} key={i} />
        ))}
      </div>
      <div className={classes.content}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              {times(7, (i) => (
                <TableCell key={i}>
                  <Skeleton className={classes.columnHeader} variant="rect" width={'100px'} />
                </TableCell>
              ))}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {times(8, (i) => (
              <TableRow key={i}>
                <TableCell>
                  <Checkbox checked={i > 3} />
                </TableCell>
                {times(6, (j) => (
                  <TableCell key={j}>
                    <Skeleton variant="rect" width={'100px'} />
                  </TableCell>
                ))}
                <TableCell>
                  <Skeleton className={classes.circle} variant="rect" width={'25px'} height={'25px'} key={i} />
                </TableCell>
                <TableCell>
                  <ActionIcon />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  )
}
